"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewOptionsApp = exports.ViewOption = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var multiSelect_1 = require("../lib/multiSelect");
var App_1 = require("../../App");
var iterUtils_1 = require("../lib/iterUtils");
var generic_1 = require("../generic");
var simulationTab_1 = require("./simulationTab");
var buttons_1 = require("../buttons");
var overviewApp_1 = require("./overviewApp");
var ViewOption = (function (_super) {
    __extends(ViewOption, _super);
    function ViewOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewOption.prototype.handleDefinitionChange = function (event) {
        var target = event.target;
        App_1.store.overview.viewOptions.set_selected_definition(this.props.definition.index, parseInt(target.value));
    };
    ViewOption.prototype.render = function () {
        var definition = this.props.definition;
        if (definition.values.length < 2)
            return null;
        var options = definition.values.map(function (option, index) {
            return (React.createElement("option", { key: index, value: index }, option.name));
        });
        return (React.createElement("div", { className: "filter_input filter_template form-group" },
            React.createElement("label", null,
                definition.name,
                " ",
                gettext("Matrix Template")),
            React.createElement("select", { onChange: this.handleDefinitionChange.bind(this), className: "form-control view-option__select" }, options)));
    };
    ViewOption = __decorate([
        mobx_react_1.observer
    ], ViewOption);
    return ViewOption;
}(React.Component));
exports.ViewOption = ViewOption;
var ViewOptionsApp = (function (_super) {
    __extends(ViewOptionsApp, _super);
    function ViewOptionsApp(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeEvaluationType = function (value, checked) { return _this.applyChange(value.toString(), checked, "evaluation"); };
        _this.onCheckAllEvaluationType = function () { return _this.onCheckAll("evaluation"); };
        _this.onUnCheckAllEvaluationType = function () { return _this.onUncheckAll("evaluation"); };
        _this.isEvalTypeSelected = function (status) { return _this.isSelected(status, App_1.store.overview.viewOptions.eval_types); };
        var percentiles = [];
        for (var i = 5; i <= 95; i += 5) {
            percentiles.push(i.toString());
        }
        _this.state = {
            all_evaluation_type_values: ["10", "20", "30"],
            percentile_values: percentiles,
        };
        return _this;
    }
    ViewOptionsApp.prototype.storeEvalTypes = function (eval_types) {
        App_1.store.overview.viewOptions.set_eval_types(eval_types);
    };
    ViewOptionsApp.prototype.handleNumberChange = function (event) {
        var target = event.target;
        App_1.store.overview.viewOptions.set_number_to_show(target.value);
    };
    ViewOptionsApp.prototype.handleShowCostChange = function (e) {
        App_1.store.overview.viewOptions.set_include_costs(e.currentTarget.checked);
    };
    ViewOptionsApp.prototype.onChangeShowQuantitative = function (event) {
        var target = event.target;
        App_1.store.overview.viewOptions.set_show_quantitative(target.checked);
    };
    ViewOptionsApp.prototype.updateStatusChoices = function (value, checked, list) {
        var listCopy = list.slice();
        if (checked && !this.isSelected(value, list)) {
            listCopy.push(value);
        }
        else if (!checked && this.isSelected(value, list)) {
            var position = listCopy.indexOf(value);
            listCopy.splice(position, 1);
        }
        return listCopy;
    };
    ViewOptionsApp.prototype.applyChange = function (value, checked, type) {
        var evaluation_type_to_display = App_1.store.overview.viewOptions.eval_types.slice();
        if (type == "evaluation") {
            evaluation_type_to_display = this.updateStatusChoices(value, checked, evaluation_type_to_display);
            this.storeEvalTypes(evaluation_type_to_display);
        }
    };
    ViewOptionsApp.prototype.onCheckAll = function (type) {
        var evaluation_type_to_display = App_1.store.overview.viewOptions.eval_types.slice();
        if (type == "evaluation") {
            evaluation_type_to_display = this.state.all_evaluation_type_values;
            this.storeEvalTypes(evaluation_type_to_display);
        }
    };
    ViewOptionsApp.prototype.onUncheckAll = function (type) {
        var evaluation_type_to_display = App_1.store.overview.viewOptions.eval_types.slice();
        if (type == "evaluation") {
            evaluation_type_to_display = [];
            this.storeEvalTypes(evaluation_type_to_display);
        }
    };
    ViewOptionsApp.prototype.isSelected = function (status, to_display_list) {
        return to_display_list.indexOf(status) != -1;
    };
    ViewOptionsApp.prototype.onChangePercentile = function (percentile, checked) {
        var percentiles = App_1.store.overview.viewOptions.percentiles.slice();
        if (checked && !(0, iterUtils_1.contains)(percentiles, percentile))
            percentiles.push(percentile);
        else if (!checked && (0, iterUtils_1.contains)(percentiles, percentile))
            percentiles.splice(percentiles.indexOf(percentile), 1);
        App_1.store.overview.viewOptions.set_percentiles(percentiles);
    };
    ViewOptionsApp.prototype.onCheckAllPercentiles = function () {
        App_1.store.overview.viewOptions.set_percentiles(this.state.percentile_values);
    };
    ViewOptionsApp.prototype.onUnCheckAllPercentiles = function () {
        App_1.store.overview.viewOptions.set_percentiles([]);
    };
    ViewOptionsApp.prototype.onChangeSimulations = function (e) {
        App_1.store.overview.viewOptions.set_simulations(parseInt(e.currentTarget.value));
    };
    ViewOptionsApp.prototype.onChangeDistribution = function (e) {
        App_1.store.overview.viewOptions.set_distribution(parseInt(e.currentTarget.value));
    };
    ViewOptionsApp.prototype.onChangeSimulationMatrix = function (matrix, checked) {
        var matrices = App_1.store.overview.viewOptions.selectedSimulationMatrices.slice();
        if (checked && !(0, iterUtils_1.contains)(matrices, matrix))
            matrices.push(matrix);
        else if (!checked && (0, iterUtils_1.contains)(matrices, matrix))
            matrices.splice(matrices.indexOf(matrix), 1);
        App_1.store.overview.viewOptions.set_simulation_matrices(matrices);
    };
    ViewOptionsApp.prototype.onCheckAllSimulationMatrices = function () {
        App_1.store.overview.viewOptions.set_simulation_matrices(App_1.store.overview.viewOptions.simulationMatrices.map(function (choice) { return choice.value; }));
    };
    ViewOptionsApp.prototype.onUnCheckAllSimulationMatrices = function () {
        App_1.store.overview.viewOptions.set_simulation_matrices([]);
    };
    ViewOptionsApp.prototype.onRunSimulationsClick = function () {
        App_1.store.overview.simulationTab.reloadTab();
    };
    ViewOptionsApp.prototype.render = function () {
        var definitions = [];
        App_1.store.overview.matrixTab.data.forEach(function (matrix, index) {
            var defs = [];
            matrix.defs.forEach(function (definition) {
                defs.push({ name: definition.project_title });
            });
            var label = matrix.name + "_" + matrix.unit;
            var title = interpolate("%s (%s)", [
                matrix.name,
                matrix.is_opportunity ? gettext("Opp.") : gettext("Risk")
            ]);
            definitions.push({
                label: label,
                values: defs,
                name: title,
                unit: matrix.unit,
                index: index
            });
            App_1.store.overview.viewOptions.set_selected_definition(index, 0);
        });
        var evaluation_choices = [
            { display_name: gettext("Gross"), value: "10" },
            { display_name: gettext("Present"), value: "20" },
            { display_name: gettext("Nett"), value: "30" }
        ];
        var percentile_choices = this.state.percentile_values.map(function (p) { return ({ display_name: p, value: p }); });
        return (React.createElement("div", { className: "form_container view_option" },
            React.createElement("form", null,
                React.createElement("div", { className: "header" },
                    React.createElement("h3", null, gettext("View Options"))),
                React.createElement("div", { id: "view_option" },
                    React.createElement("div", { className: "filter_input filter_eval" },
                        React.createElement(multiSelect_1.Multiselect, { name: "eval_filter", choices: evaluation_choices, selectedText: gettext("evaluation type(s) selected"), noneSelectedText: gettext("Select evaluation types"), value: App_1.store.overview.viewOptions.eval_types, onSingleChange: this.onChangeEvaluationType.bind(this), onCheckAll: this.onCheckAllEvaluationType.bind(this), onUncheckAll: this.onUnCheckAllEvaluationType.bind(this), classes: "gm--fullwidth" })),
                    React.createElement("div", { className: "form-group filter_input filter_number" },
                        React.createElement("label", { className: "form-label" }, gettext("Number to show")),
                        React.createElement("select", { value: App_1.store.overview.viewOptions.number_to_show, className: "form-control view-option__select", onChange: this.handleNumberChange.bind(this) },
                            React.createElement("option", null, "5"),
                            React.createElement("option", null, "10"),
                            React.createElement("option", null, "15"),
                            React.createElement("option", null, "20"),
                            React.createElement("option", null, "30"),
                            React.createElement("option", null, "50"),
                            React.createElement("option", null, "All"))),
                    React.createElement("div", { className: "form-group filter_input matrix_mode" },
                        React.createElement("div", { className: "custom-control custom-switch" },
                            React.createElement("input", { type: "checkbox", id: "id_show_quantitative", className: "custom-control-input", onChange: this.onChangeShowQuantitative.bind(this), checked: App_1.store.overview.viewOptions.show_quantitative }),
                            React.createElement("label", { htmlFor: "id_show_quantitative", className: "custom-control-label" }, gettext("Use quantitative matrices")))),
                    React.createElement("div", { className: "form-group filter_input include_costs" },
                        React.createElement("div", { className: "custom-control custom-switch" },
                            React.createElement("input", { id: "overview-cost-option", className: "custom-control-input", type: "checkbox", onChange: this.handleShowCostChange.bind(this) }),
                            React.createElement("label", { className: "form-label custom-control-label", htmlFor: "overview-cost-option" }, gettext("Cost of controls")))),
                    definitions.map(function (definition, def_key) {
                        return (React.createElement(ViewOption, { key: def_key, definition: definition }));
                    }),
                    React.createElement("div", { className: "simulation_options" },
                        React.createElement("div", { className: "filter_input" },
                            React.createElement(multiSelect_1.Multiselect, { name: "percentiles", choices: percentile_choices, selectedText: gettext("percentile(s) selected"), noneSelectedText: gettext("Select percentiles"), value: App_1.store.overview.viewOptions.percentiles, onSingleChange: this.onChangePercentile.bind(this), onCheckAll: this.onCheckAllPercentiles.bind(this), onUncheckAll: this.onUnCheckAllPercentiles.bind(this), classes: "gm--fullwidth" })),
                        React.createElement("br", null),
                        React.createElement("div", { className: "header" },
                            React.createElement("h3", null, gettext("Simulation Options"))),
                        React.createElement("div", { id: "view_option" },
                            React.createElement("div", { className: "form-group" },
                                React.createElement("label", { className: "form-label" }, gettext("Matrices")),
                                React.createElement(multiSelect_1.Multiselect, { name: "simulation_matrices", choices: App_1.store.overview.viewOptions.simulationMatrices, selectedText: gettext("selected"), noneSelectedText: gettext("Select matrices"), value: App_1.store.overview.viewOptions.selectedSimulationMatrices, onSingleChange: this.onChangeSimulationMatrix.bind(this), onCheckAll: this.onCheckAllSimulationMatrices.bind(this), onUncheckAll: this.onUnCheckAllSimulationMatrices.bind(this), classes: "gm--fullwidth" })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("label", { className: "form-label" }, gettext("Probability distribution")),
                                React.createElement(generic_1.ChoiceSelect, { choices: simulationTab_1.SimulationDistributionChoices.asChoices(), value: App_1.store.overview.viewOptions.simulationDistribution, onChange: this.onChangeDistribution.bind(this) })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("label", { className: "form-label" }, gettext("No. of simulations")),
                                React.createElement("input", { type: "number", className: "form-control", value: App_1.store.overview.viewOptions.simulations, onChange: this.onChangeSimulations.bind(this) })),
                            React.createElement(buttons_1.PrimaryButton, { onClick: this.onRunSimulationsClick.bind(this), disabled: App_1.store.overview.simulationTab.isLoading, type: "button", fullWidth: true },
                                gettext("Apply"),
                                App_1.store.overview.simulationTab.isLoading && React.createElement(overviewApp_1.TabSpinner, null))))))));
    };
    ViewOptionsApp = __decorate([
        mobx_react_1.observer
    ], ViewOptionsApp);
    return ViewOptionsApp;
}(React.Component));
exports.ViewOptionsApp = ViewOptionsApp;
